var _style, _g, _defs, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 82 50",
    style: {
      enableBackground: "new 0 0 82 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#D8D8D8;stroke-miterlimit:10;}\n\t.st2{fill:#28356A;}\n\t.st3{fill:#298FC2;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    transform: "translate(-171 -327)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    transform: "translate(171 327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2_00000163045440715545755370000011334318756701406111_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,0h66c4.4,0,8,3.6,8,8v34c0,4.4-3.6,8-8,8H8c-4.4,0-8-3.6-8-8V8C0,3.6,3.6,0,8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,0.5h66c4.1,0,7.5,3.4,7.5,7.5v34c0,4.1-3.4,7.5-7.5,7.5H8c-4.1,0-7.5-3.4-7.5-7.5V8 C0.5,3.9,3.9,0.5,8,0.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M179,327h66c4.4,0,8,3.6,8,8v34c0,4.4-3.6,8-8,8h-66c-4.4,0-8-3.6-8-8v-34C171,330.6,174.6,327,179,327z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005231140657641365330000012767066272767940992_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(171 327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paypal",
    transform: "translate(12 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "st2",
    d: "M-168.4-314.3h-2.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l1.8-11.4 c0-0.3,0.3-0.5,0.6-0.5h4.5c1.2-0.1,2.4,0.3,3.3,1.1c0.6,0.8,0.8,1.9,0.6,2.9c-0.4,2.8-2.2,4.2-5.1,4.2h-1.4 c-0.3,0-0.6,0.2-0.6,0.5l-0.5,3.1C-167.8-314.5-168.1-314.2-168.4-314.3z M-166-324.2c-0.2,0-0.3,0.1-0.4,0.3l-0.5,3h0.7 c1.2,0,2.4,0,2.7-1.6c0.1-0.4,0-0.9-0.2-1.2c-0.4-0.5-1.2-0.5-2-0.5L-166-324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    className: "st2",
    d: "M-157.1-314.1c-1,0.1-2-0.3-2.7-1.1c-0.7-0.9-1-2.1-0.8-3.3c0.3-2.4,2.4-4.2,4.8-4.3 c0.9-0.1,1.9,0.2,2.5,0.9l0.1,0.2l0.1-0.6c0-0.2,0.2-0.3,0.4-0.3h2.2c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3l-1.2,7.3 c0,0.3-0.3,0.5-0.6,0.5h-1.9c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l0.1-0.6l0,0C-155-314.5-156-314.1-157.1-314.1z  M-155.3-320.4c-1.2,0-2.2,0.9-2.4,2.1c-0.1,0.5,0,1.1,0.3,1.5c0.4,0.4,0.9,0.6,1.4,0.6c1.2,0,2.3-0.8,2.4-2 c0.1-0.5,0-1.1-0.4-1.5C-154.3-320.3-154.8-320.5-155.3-320.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    className: "st2",
    d: "M-139.1-322.5h-2.2c-0.2,0-0.4,0.1-0.5,0.3l-3,4.4l-1.3-4.2c-0.1-0.3-0.3-0.4-0.6-0.4h-2.1 c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0.1,0,0.1l2.4,6.9l-2.2,3.1c-0.1,0.2-0.1,0.4,0.1,0.5c0.1,0,0.1,0.1,0.2,0.1h2.2 c0.2,0,0.4-0.1,0.5-0.3l7.2-10.3c0.1-0.2,0.1-0.4-0.1-0.5C-138.9-322.5-139-322.5-139.1-322.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "st3",
    d: "M-136.1-314.3h-2.3c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l1.8-11.4 c0-0.3,0.3-0.5,0.6-0.5h4.5c1.2-0.1,2.4,0.3,3.3,1.1c0.6,0.8,0.8,1.9,0.6,2.9c-0.4,2.8-2.2,4.2-5.1,4.2h-1.4 c-0.3,0-0.6,0.2-0.6,0.5l-0.5,3.2C-135.7-314.4-135.9-314.2-136.1-314.3z M-133.9-324.2c-0.2,0-0.3,0.1-0.4,0.3l-0.5,3h0.7 c1.2,0,2.4,0,2.7-1.6c0.1-0.4,0-0.9-0.2-1.2c-0.4-0.5-1.2-0.5-2-0.5L-133.9-324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    className: "st3",
    d: "M-125-314.1c-1,0.1-2-0.3-2.7-1.1c-0.7-0.9-1-2.1-0.8-3.3c0.3-2.4,2.4-4.2,4.8-4.3 c0.9-0.1,1.9,0.2,2.5,0.9l0.2,0.2l0.1-0.6c0-0.2,0.2-0.3,0.4-0.3h2.2c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3l-1.2,7.3 c0,0.3-0.3,0.5-0.6,0.5h-1.9c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l0.1-0.6l0,0C-122.9-314.5-123.9-314-125-314.1z  M-123.2-320.4c-1.2,0-2.2,0.9-2.4,2.1c-0.1,0.5,0,1.1,0.3,1.5c0.4,0.4,0.9,0.6,1.4,0.6c1.2,0,2.3-0.8,2.4-2 c0.1-0.5,0-1.1-0.4-1.5C-122.2-320.3-122.7-320.5-123.2-320.4L-123.2-320.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    className: "st3",
    d: "M-115.9-326.3l-1.9,11.6c0,0.2,0.1,0.4,0.3,0.4c0,0,0,0,0.1,0h1.9c0.3,0,0.6-0.2,0.6-0.5 l1.8-11.4c0-0.2-0.1-0.4-0.3-0.4c0,0,0,0-0.1,0h-2.1C-115.7-326.6-115.9-326.5-115.9-326.3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.cd7e0bd29b2fb0d098e056e87680de89.svg";
export { ForwardRef as ReactComponent };